import { SWReactIcons } from "@similarweb/icons";
import { IconButton, PlainTooltip } from "@similarweb/ui-components";

import { StyledItemIcon } from "pro-features/components/core cells/src/CoreRecentCell/StyledComponents";
import { WebsiteTooltip } from "app/components/React/Tooltip/WebsiteTooltip/WebsiteTooltip";
import { translate } from "app/filters/i18nFilter";
import { Type } from "pro-features/pages/app performance/src/page/StyledComponents";
import type { IDomain } from "app/pages/industry-analysis/market-builder/MarketBuilder.types";

import { DomainItemContainer, Domain, RecomendationListItemWrapper, RedirectToUrl } from "./StyledComponents";

interface IRecomendationListItem {
    entity: IDomain;
    onAddClick: (IDomain) => void;
    isDisabled: boolean;
}

const RecomendationListItem = ({ entity, onAddClick, isDisabled }: IRecomendationListItem) => {
    return (
        <RecomendationListItemWrapper data-automation="RecomendationListItem">
            <DomainItemContainer>
                <StyledItemIcon
                    iconType={Type.Website}
                    iconSrc={entity.favicon}
                />
                <WebsiteTooltip
                    domain={entity.domain}
                    hideTrackButton={true}
                >
                    <Domain>{entity.domain}</Domain>
                </WebsiteTooltip>
                <RedirectToUrl
                    href={`http://${entity.domain}`}
                    target="_blank"
                >
                    <SWReactIcons iconName={"bounce-rate"} />
                </RedirectToUrl>
            </DomainItemContainer>
            <PlainTooltip
                cssClass="plainTooltip-element"
                tooltipContent={translate("marketbuilder.import.disable.tooltip")}
                placement="top"
                enabled={isDisabled}
            >
                <IconButton
                    onClick={() => onAddClick(entity)}
                    type="flat"
                    iconName="plus"
                    iconSize="10px"
                    isDisabled={isDisabled}
                >
                    {translate("marketbuilder.add.button")}
                </IconButton>
            </PlainTooltip>
        </RecomendationListItemWrapper>
    );
};

export default RecomendationListItem;
